// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__MHcUG","colMaxWidth":"Table_colMaxWidth__2553J"};